import React from 'react';
import { useAllCategoryData } from '../../../../hooks/UseCategoryData';

export default function AllCategoriesPage() {
  const { categories, loading, error } = useAllCategoryData();

  const renderCategoryTree = (allCats, parentId = null, level = 0) => {
    const children = allCats.filter(cat => cat.parent_id === parentId);

    return children.map(child => {
      // Render this child
      const rendered = [
        <div key={`cat-${child.id}`} style={{ marginLeft: `${level * 20}px`, padding: '4px 0' }}>
          <span className="font-mono text-sm">[{child.id}]</span> <strong>{child.name}</strong> — <em>{child.type}</em> <span>({child?.country_code || 'MASTER'})</span> {!child.is_active && '(Inactive)'}
        </div>
      ];

      // Only add avatars for this child if it's a child
      if (child.type === 'child') {
        const avatars = allCats.filter(av => av.inherits_from === child.id);
        avatars.forEach(avatar => {
          rendered.push(
            <div key={`av-${avatar.id}`} style={{ marginLeft: `${(level + 1) * 20}px`, padding: '4px 0' }}>
              <span className="font-mono text-sm">[{avatar.id}]</span> {avatar.name} — <em>{avatar.type}</em> {!avatar.is_active && '(Inactive)'}
            </div>
          );
        });
      }

      // Add sub-children of this child (but skip avatars)
      rendered.push(...renderCategoryTree(allCats, child.id, level + 1));

      return rendered;
    });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">All Categories</h1>
      {loading && <p>Loading...</p>}
      {error && <p className="text-red-600">❌ Error: {error}</p>}
      <div className="mt-4">
        {renderCategoryTree(categories)}
      </div>
    </div>
  );
}
